import TrailingReturnsChart from "components/charts/modern/TrailingReturnsChart";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import SadFaceIcon from "components/icons/SadFaceIcon";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import { FormattedMessage } from "react-intl";

export default function AmericanHistoricalReturnContent() {
  const issuer = useAmericanIssuer();

  const trailingReturns = issuer.securities.map((security) => security.trailingReturns).filter(notUndefinedOrNull);

  if (trailingReturns.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <p>
            <FormattedMessage defaultMessage="Nenhum dado foi encontrado." id="i1Elih" />
          </p>
        </div>
      </div>
    );
  }

  return <TrailingReturnsChart tickerSymbols={issuer.tickerSymbols} tradingCurrency="USD" />;
}
